import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowDown } from 'iconsax-react';
import { useState } from 'react';
import { ActionCard } from './style';
import { yellowMain, black200, black500 } from '../../../constants/color';
export const CustomCard = ({ title, count, isActive, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (_jsxs(Box, { sx: {
            ...ActionCard,
            // Two per row on phones (QPortal UX review): smaller than the desktop tiles.
            height: { xs: 64, sm: ActionCard.height },
            padding: { xs: '12px 16px', sm: ActionCard.padding },
            backgroundColor: isActive ? yellowMain : 'white',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: isActive ? yellowMain : black200
            }
        }, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), onClick: onClick, children: [_jsx(Typography, { variant: 'subtitle2', color: '#000', children: title }), isHovered ? (_jsx(IconButton, { sx: {
                    background: black500,
                    '&:hover': {
                        backgroundColor: black500
                    }
                }, children: _jsx(ArrowDown, { style: { transform: 'rotate(-45deg)', color: yellowMain } }) })) : (_jsx(Typography, { fontSize: { xs: 22, sm: 29 }, fontWeight: 500, color: '#000', children: count }))] }));
};
